import { render, staticRenderFns } from "./reservationSite.vue?vue&type=template&id=2278c56c"
import script from "./reservationSite.vue?vue&type=script&lang=js"
export * from "./reservationSite.vue?vue&type=script&lang=js"
import style0 from "./reservationSite.vue?vue&type=style&index=0&id=2278c56c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports